/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
    IonItem,
    IonSelect,
    IonSelectOption,
    useIonLoading,
    useIonViewWillEnter,
    useIonViewWillLeave,
} from "@ionic/react";
import { useAuth } from "../../context/Auth";
import PageWrapper from "../layouts/PageWrapper";
import { fetchOwnEquipments } from "../../services/RelationServices";
import EquipmentItem from "../../components/EquipmentItem";
import EmptyText from "../../components/EmptyText";
import { EquipmentModel } from "../../models/GlobalModels";

import "./ServicesPage.scss";

const OwnEquipmentsPage: React.FC = () => {
    const { checkAxiosError, assigns } = useAuth();
    const [realAssigns, setRealAssigns] = useState<any[]>([]);
    const [selectedAssignId, setSelectedAssignId] = useState<number | null>(
        null
    );
    const [equipments, setEquipments] = useState<{
        data: any[];
        loaded: boolean;
    }>({ data: [], loaded: false });

    const [presentLoading, dismissLoading] = useIonLoading();

    useIonViewWillEnter(() => {
        setRealAssigns(
            ((assigns ?? [])[0] ?? []).filter(
                (x: any) =>
                    (x.base_data?.related_type ?? "") ===
                    "App\\Models\\BaseDataWorker"
            )
        );
    }, [assigns]);

    useIonViewWillLeave(() => {
        setEquipments({ data: [], loaded: true });
        setSelectedAssignId(null);
    });

    // useEffect(() => {
    //     setRealAssigns(
    //         ((assigns ?? [])[0] ?? []).filter(
    //             (x: any) =>
    //                 (x.base_data?.related_type ?? "") ===
    //                 "App\\Models\\BaseDataWorker"
    //         )
    //     );
    // }, [assigns]);

    useEffect(() => {
        if ((realAssigns ?? []).length > 0 && !selectedAssignId) {
            setSelectedAssignId(realAssigns[0].id);
        }
    }, [realAssigns]);

    useEffect(() => {
        setEquipments({ data: [], loaded: false });
        if (selectedAssignId) {
            const foundAssign = realAssigns.find(
                (x) => x.id === selectedAssignId
            );
            if (foundAssign) {
                getOwnEquipments(foundAssign.base_data?.related?.tax_id ?? "");
            }
        }
    }, [selectedAssignId]);

    const getOwnEquipments = (taxId: string) => {
        presentLoading("Kérem várjon...");
        fetchOwnEquipments(taxId)
            .then((res) => {
                setEquipments({
                    data: (res.data?.data ?? []).sort(
                        (a: EquipmentModel, b: EquipmentModel) => {
                            return a.name.localeCompare(b.name);
                        }
                    ),
                    loaded: true,
                });
            })
            .catch((err) => {
                checkAxiosError(err);
                setEquipments({ data: [], loaded: true });
            })
            .finally(() => dismissLoading());
    };

    return (
        <PageWrapper>
            <div className="hasButton">
                <h1 className="pageTitle">Dolgozói karton</h1>
            </div>

            <div className="inputWithModalWrapper">
                <IonItem
                    className="inputWithModal highlightedSelect"
                    lines="none"
                >
                    <IonSelect
                        cancelText="Mégse"
                        interface="action-sheet"
                        className="fullLength"
                        value={selectedAssignId}
                        placeholder="Kérem válasszon"
                        onIonChange={(e) => setSelectedAssignId(e.detail.value)}
                    >
                        {((assigns ?? [])[0] ?? [])
                            .filter(
                                (x: any) =>
                                    (x.base_data?.related_type ?? "") ===
                                    "App\\Models\\BaseDataWorker"
                            )
                            .map((assign: any, index: number) => (
                                <IonSelectOption
                                    key={assign.id}
                                    value={assign.id}
                                >
                                    {assign?.base_data?.name}
                                    {(assign?.base_data?.related?.tax_id ??
                                        "") !== ""
                                        ? ` - ${assign.base_data.related.tax_id}`
                                        : ""}
                                </IonSelectOption>
                            ))}
                    </IonSelect>
                </IonItem>
            </div>

            {equipments.loaded && (
                <>
                    {(equipments.data ?? []).length > 0 ? (
                        (equipments?.data ?? []).map(
                            (equipment: any, index: number) => (
                                <EquipmentItem
                                    key={equipment.id}
                                    equipment={equipment}
                                />
                            )
                        )
                    ) : (
                        <EmptyText
                            text="Nincs megjeleníthető adat"
                            // subtext="Nem található adat amely módosítható lenne, kérem keresse fel ügyintézőnket a hibával kapcsolatban."
                        />
                    )}
                </>
            )}
        </PageWrapper>
    );
};

export default OwnEquipmentsPage;
